import ReportPage from './ReportPage';
import reportPageReducer from './reducer';

export { reportPageReducer };
export default ReportPage;
